<div>
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    [isAdvanceSearch]="true"
    (onAdvanceSearch)="searchAd($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="15px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="10">IP Address</div>
      <div fxFlex="15">Username</div>
      <div fxFlex="10">Action</div>
      <div fxFlex="10">Timestamp</div>
      <div fxFlex="25">File Name</div>
      <div fxFlex="10">File Type</div>
      <div fxFlex="10">File Size(Bytes)</div>
      <div fxFlex="10">Status</div>
    </div>
    <app-file-log-row
      *ngFor="let log of logs"
      [log]="log"
      (viewLog)="viewLogDetail($event)"
      (blacklistIPAddress)="openBlacklistIPAddressModal($event)"
      (createAlert)="onCreateLogAlertModal($event)"
    ></app-file-log-row>

    <app-no-record-found *ngIf="logs && logs.length < 1"></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
